import { IApplicationState } from '../../types/redux';

export const getAeroPhotoTourLink = (state: IApplicationState) => {
  const { panorama } = state.newbuilding;

  return (panorama && panorama.url) || null;
};
